<template>
    <v-row class="fill-height ma-n8" align="center">
        <template v-for="(peer, index) in peers">
            <v-col v-bind="colProps" class="pa-8" :key="index">
                <room-video v-bind="peer" />
            </v-col>
        </template>
    </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import RoomVideo from "./room-video.vue";
export default {
    components: {
        RoomVideo,
    },
    computed: {
        ...mapGetters("interview/server", ["peers"]),
        colProps() {
            let props = {
                cols: 12,
                sm: 12,
                md: 12,
                lg: 12,
            };
            switch (this.peers.length) {
                case 0: {
                    break;
                }
                case 1: {
                    break;
                }
                case 2: {
                    props.md = 6;
                    props.lg = 6;
                    break;
                }
                case 3: {
                    props.sm = 6;
                    props.md = 6;
                    props.lg = 6;
                    break;
                }
                case 4: {
                    props.sm = 6;
                    props.md = 6;
                    props.lg = 6;
                    break;
                }
                default: {
                    props.sm = 6;
                    props.md = 4;
                    props.lg = 4;
                    break;
                }
            }

            return props;
        },
    },
};
</script>

<style>
</style>